import { render } from "./ErequisitionViewOrders.vue?vue&type=template&id=4ae0358b&scoped=true"
import script from "./ErequisitionViewOrders.vue?vue&type=script&lang=js"
export * from "./ErequisitionViewOrders.vue?vue&type=script&lang=js"

import "./ErequisitionViewOrders.vue?vue&type=style&index=0&id=4ae0358b&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae0358b"],['__file',"src/components/orders/ErequisitionViewOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ae0358b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ae0358b', __exports__)) {
    console.log('reload')
    api.reload('4ae0358b', __exports__)
  }
  
  module.hot.accept("./ErequisitionViewOrders.vue?vue&type=template&id=4ae0358b&scoped=true", () => {
    console.log('re-render')
    api.rerender('4ae0358b', render)
  })

}


export default __exports__